import React, {useEffect, useImperativeHandle} from "react";
import {Col, Form, Input, Row, Select} from "antd";
import {CM_ACTION_TYPE} from "../../../utils/constants";
import {useModel,useModelDispatchers} from "../../../models";
import WarehouseService from "./WarehouseService";
import {useHistory} from "react-router";
import {goPage} from "../../layout/pageDefinition";
export default function ({cRef, actionType}) {
    const history = useHistory();
    const [
        {orgDict}, {getOrgDict}] = useModel("cmDict");

    useEffect(() => {
        getOrgDict();
    }, []);

    const [{selectedWarehouse}, {insertWarehouse, updateWarehouse}] = useModel("warehouse");
    const [{userInfo}] = useModel("global");
    const {closeNav} = useModelDispatchers("nav");

    const [form] = Form.useForm();

    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            if (selectedWarehouse) {
                form.setFieldsValue(selectedWarehouse);
            }
        }
        form.setFieldsValue({orgName:"天路云卡张家口汽车销售有限公司"})
    }, [actionType, selectedWarehouse])

    useImperativeHandle(cRef, () => ({
        insert: () => {
            form.validateFields().then(datas => {
                let data = {
                    ...datas,
                    orgId:userInfo.orgId,            
                    // orgName:"这里缺少后期传"
                }
                insertWarehouse({data}).then(id => {
                    // console.log(id)
                    if (!!id) {
                        form.setFieldsValue({warehouseCode: id})
                        closeNav();
                        goPage(history, "6-2");
                    }

                    
                })
            })
        },
        update:() => {
            form.validateFields().then(datas =>{
                let data = {
                    ...datas,
                    id:selectedWarehouse.id
                }
                // let ret = await updateWarehouse({data})
                // console.log(ret)
                updateWarehouse({data}).then(res =>{
                    if (!!res) {
                        closeNav();
                        goPage(history, "6-2");
                    }                  
                })
                // updateWarehouse({data}).then(id =>{
                //     console.log(id)
                // })
            })

        },
        reset:()=>{
            form.resetFields();
            form.setFieldsValue({orgName:"天路云卡张家口汽车销售有限公司"})
            if(actionType === CM_ACTION_TYPE.EDIT){
                form.setFieldsValue({warehouseCode:selectedWarehouse.warehouseCode})
            }
        }
    }))
    const onGenerateId = async () => {
        let id = await WarehouseService.generateID();
        form.setFieldsValue({
            warehouseCode: id,
        });
    }


    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
        >
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="warehouseCode"
                        label="仓库编码"
                        rules={[
                            {
                                required: true,
                                message: '请输入仓库编码!',
                            },
                        ]}
                    >
                        {/*<Input
                            disabled={true}
                            {...actionType === CM_ACTION_TYPE.INSERT ? {
                                addonAfter: (
                                    <Button type="link" htmlType="button" onClick={onGenerateId}
                                            className="margin-left-8">获取</Button>)
                            } : {}}
                            placeholder="仓库编码"/>*/}
                        <Input disabled={actionType === CM_ACTION_TYPE.EDIT} placeholder="仓库编码"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="warehouseName"
                        label="仓库名称"
                        rules={[
                            {
                                required: true,
                                message: '请输入仓库名称!',
                            },
                        ]}
                    >
                        <Input  placeholder="仓库名称"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="orgName"
                        label="公司"
                    >
                        <Input disabled placeholder="公司"/>
                    </Form.Item>
                    {/* <Form.Item
                        name="orgName"
                        label="公司"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="公司"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={orgDict}
                        />
                    </Form.Item> */}
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="warehousePerson"
                        label="负责人"
                    >
                        <Input placeholder="负责人"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="warehousePhone"
                        label="电话"
                    >
                        <Input placeholder="电话"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="warehouseAddress"
                        label="地址"
                    >
                        <Input placeholder="地址"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="warehouseDesc"
                        label="备注"
                        labelCol={{span: 3}}
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
                </Col>
            </Row>

        </Form>
    )

};